import Immutable from 'seamless-immutable'
import thunk from 'redux-thunk'
import { composeWithDevTools } from '@redux-devtools/extension';
import { reduxBatch } from '@manaflair/redux-batch'
import { createStore, applyMiddleware, compose } from 'redux'
import { createReducer } from './createReducer'

type ComposeFunction = (...args: any[]) => any;
const composeEnhancers: ComposeFunction = (process.env.NODE_ENV !== 'production') ? composeWithDevTools : compose;

export const configureStore = (initialState, injectedReducers) => {
  return createStore(
    createReducer(injectedReducers),
    Immutable(initialState),
    composeEnhancers(reduxBatch, applyMiddleware(thunk))
  )
}